export const isTechAdmin = (user = {}) => {
  const role = user.userType || user.role || user.accountType || "";
  const normalized = String(role).trim().toUpperCase().replace(/[\s-]+/g, "_");
  return normalized === "TECH_ADMIN" || normalized === "TECHADMIN";
};
